import { render, staticRenderFns } from "./FolderOfferRemindLogsDialog.vue?vue&type=template&id=098332a1&scoped=true"
import script from "./FolderOfferRemindLogsDialog.vue?vue&type=script&lang=js"
export * from "./FolderOfferRemindLogsDialog.vue?vue&type=script&lang=js"
import style0 from "./FolderOfferRemindLogsDialog.vue?vue&type=style&index=0&id=098332a1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "098332a1",
  null
  
)

export default component.exports